import {SCROLL_DOWN, SCROLL_UP} from "../actions/PanelScrolling";

const initialState = {
    direction: "up"
};


const panelScrollingReducer = (state = initialState, action) => {
    switch (action.type) {
        case SCROLL_DOWN:
        case SCROLL_UP:
            return {
                scroll_direction: action.payload.scroll_direction
            };
        default:
            return state
    }
};


export default panelScrollingReducer;
